<template>
  <section class="blaFourthSection">
    <div class="row pa-2 align-items-center">
      <div class="col-10 offset-1 col-md-8 offset-md-2">
        <div class="row">
          <div class="col-12 col-md-6">
            <div class="blaFourthSectionTitle">
              Kinek ajánljuk?
            </div>
            <p class="blaSectionDescriptionWhite my-5">
              Az oktatási platformot úgy alakítottuk ki,
              hogy széles körben alkalmazható legyen.
              KKV? Multinacionális Nagyvállalat? A való
              életre épülő nyelvi képzésünket kezdő és haladó munkatársainak egyaránt ajánljuk,
              akik még egy játékos versenyben is részt vehetnek. A vállalat arculatára szabott 
              játékosított rendszerben munkatársai folyamatosan pontokat gyűjtenek, 
              így lépkednek előre a vállalati ranglistán.
              <br>
              <br>
              Szeretné még jobban berobbantani csapata motivációját?
              Mi lenne, ha kihívnák egy másik vállalat csapatát egy nyelvtanulós challenge-re?
            </p>
            <!-- <div
              class="clickable mt-3 blaPrimaryButton px-3 py-3"
              @click="goToUrl('https://skillers.hu/business/sub')"
            >
              <span class=""> Megrendelés </span>
            </div> -->
            <!--<div-->
            <!--  class="clickable mt-3 d-none d-md-block"-->
            <!--  @click="$router.push({ name: 'WebApp' })"-->
            <!--&gt;-->
            <!--  <span class="blaPrimaryButton px-3 py-3">-->
            <!--    Csomagváltás-->
            <!--  </span>-->
            <!--</div>-->
          </div>
          <div class="col-12 col-md-6">
            <div class="d-inline-block">
              <img
                :src="
                  require('@/assets/images/Skillers_ikonok14-B9823D48-19B3-44B3-8B21-13109E77F9B7.png')
                "
                alt="get_it_google"
                class="blaFourthSectionImg img-fluid"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {},
  data: () => ({}),
  methods: {
    goToUrl(url) {
      window.location.href = url;
    },
  },
  props: {},
  mounted: () => ({}),
};
</script>
